var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailwindcss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 100,
    viewBox: "0 0 167 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1169 0C60.9526 0 47.0994 11.0825 41.5584 33.2468C49.8701 22.1643 59.5669 18.0084 70.6494 20.7792C76.9721 22.3597 81.4916 26.9474 86.4942 32.0247C94.6435 40.2967 104.075 49.8701 124.675 49.8701C146.84 49.8701 160.693 38.7877 166.234 16.6234C157.922 27.7058 148.225 31.8617 137.143 29.0909C130.82 27.5104 126.301 22.9227 121.298 17.8455C113.149 9.57338 103.718 0 83.1169 0ZM41.5584 49.8701C19.3942 49.8701 5.54091 60.9526 0 83.1169C8.31169 72.0344 18.0084 67.8786 29.0909 70.6493C35.4136 72.2299 39.9331 76.8175 44.9357 81.8948C53.0851 90.1669 62.5162 99.7403 83.1169 99.7403C105.281 99.7403 119.134 88.6578 124.675 66.4935C116.364 77.576 106.667 81.7318 95.5844 78.961C89.2617 77.3805 84.7422 72.7928 79.7396 67.7156C71.5903 59.4435 62.1591 49.8701 41.5584 49.8701Z",
    fill: "url(#paint0_linear_204_331)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_331",
    x1: -4.61797,
    y1: 31.9169,
    x2: 138.952,
    y2: 114.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2298BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED7B5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.234,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindcss);
export default __webpack_public_path__ + "static/media/tailwindcss.ef369da6fda5b3b80fa2ca5c2b18769d.svg";
export { ForwardRef as ReactComponent };